import React from 'react';
import { CheckCircle, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const cqcRatings = [
  { category: 'Safe', rating: 'Good' },
  { category: 'Effective', rating: 'Good' },
  { category: 'Caring', rating: 'Good' },
  { category: 'Responsive', rating: 'Good' },
  { category: 'Well-led', rating: 'Good' },
];

const CQCSection = () => {
  return (
    <section
      id="cqc"
      className="py-20 md:py-32 bg-gradient-to-br from-[#1e3a5f] to-[#162c4a]"
      data-testid="cqc-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/20 rounded-full text-emerald-400 text-sm font-medium mb-6">
              <CheckCircle className="w-4 h-4" />
              CQC Regulated
            </div>
            
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
             
            >
              Rated <span className="text-[#c9a227]">Good</span> by the Care Quality Commission
            </h2>

            <p className="text-white/90 text-lg mb-6 leading-relaxed">
              Abney Low Nursing Home is regulated by the Care Quality Commission (CQC) and has achieved a positive rating across all categories.
            </p>

            <p className="text-white/80 mb-8 leading-relaxed">
              Following a period of improvement, the home has successfully strengthened its systems, leadership and care delivery, resulting in a positive rating and continued progress.
            </p>

            <p className="text-white/80 mb-10 leading-relaxed">
              We remain committed to maintaining and exceeding these standards through ongoing monitoring, training and quality assurance.
            </p>

            <Button
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#1e3a5f] rounded-full px-6 py-3"
              onClick={() => window.open('https://www.cqc.org.uk/location/1-12436440703', '_blank')}
              data-testid="cqc-link-btn"
            >
              View on CQC Website
              <ExternalLink className="w-4 h-4 ml-2" />
            </Button>
          </div>

          {/* Ratings Card */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-emerald-100 rounded-full mb-4">
                <CheckCircle className="w-10 h-10 text-emerald-600" />
              </div>
              <h3
                className="text-2xl font-bold text-[#1e3a5f]"
               
              >
                Overall Rating: Good
              </h3>
              <p className="text-slate-500 text-sm mt-2">Care Quality Commission</p>
            </div>

            <div className="space-y-4">
              {cqcRatings.map((item, index) => (
                <div
                  key={item.category}
                  className="flex items-center justify-between p-4 bg-slate-50 rounded-xl"
                  data-testid={`cqc-rating-${index}`}
                >
                  <span className="font-medium text-[#1e3a5f]">{item.category}</span>
                  <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium">
                    <CheckCircle className="w-4 h-4" />
                    {item.rating}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CQCSection;
